// extracted by mini-css-extract-plugin
export default {"root":"UFnf6","googleLight":"Ol8EJ","googleDark":"cXaTf"};